import BrandLogo from "../../../utils/brands/BrandLogo.jsx";
import {isAdministratorOnlyBrand} from "../../../utils/brands/brandVisibility.js";
import SuperadminIndicator from "../../../components/auth/SuperadminIndicator.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

export default function CreateIntegrationPlatform({brand, onClick, href}) {
    const {t} = useTranslation();
    const administratorOnly = isAdministratorOnlyBrand(brand);

    const className = 'comp__roundedBox relative flex h-32 w-36 flex-col items-center justify-center gap-3 select-none rounded !border !border-transparent bg-white px-3 py-2 shadow cursor-pointer transition-colors hover:!border-violet-500 hover:!bg-white dark:bg-slate-800 dark:hover:!border-violet-400 dark:hover:!bg-slate-800';
    const content = <>
        {administratorOnly && <SuperadminIndicator className={'absolute right-2 top-2 !h-6 !w-6'}/>}
        {href && <span className={'absolute right-2 top-2 inline-flex h-6 w-6 items-center justify-center rounded-md border border-slate-300 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200'} title={t('project.integration-marketplace-opens-new-tab', {defaultValue: 'Otevřít web platformy v novém panelu'})} aria-label={t('project.integration-marketplace-opens-new-tab', {defaultValue: 'Otevřít web platformy v novém panelu'})}>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className={'h-3 w-3'}/>
        </span>}
        <BrandLogo brand={brand}
            className={'shrink-0 !my-0'}
            size={10}
        />
        <div className={'text-center text-base font-medium leading-tight break-words text-slate-900 dark:text-white'}>{brand['name']}</div>
    </>;

    if (href) {
        return <a className={className} href={href} target={'_blank'} rel={'noopener noreferrer'}>
            {content}
        </a>;
    }

    return <button type={'button'} className={className} onClick={onClick}>
        {content}
    </button>;
}
